<template>
    <b-modal no-close-on-backdrop
             centered
             modal-class="x-modal"
             title="NEW ACCOUNT" ref="innerform">
        <div class="vl-parent">
            <div class="row">
                <div class="col-sm-8">
                    <div class="form-group" :class="{ 'form-group-error': $v.model.AccountTypeId.$error }">
                        <label class="label-control blue">{{ $t('account_type') }}</label>
                        <div>
                            <select class="form-control form-control-sm" v-model="$v.model.AccountTypeId.$model" @change="typeChange">
                                <option v-for="(ret,index) in types" :value="ret.Id" :key="index">{{ret.Name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label class="label-control blue">{{ $t('account_no') }} </label>
                        <div>
                            <input class="form-control form-control-sm" type="text" v-model="model.Num" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                <label class="label-control blue">{{ $t('account_name') }}</label>
                <div><input class="form-control form-control-sm" type="text" v-model="$v.model.Name.$model" /></div>
            </div>
            <div class="form-group">
                <label class="blue">{{ $t('description') }} </label>
                <div>
                    <textarea class="form-control" v-model="model.Description"></textarea>
                </div>
            </div>
            <div class="form-group">
                <label class="blue">{{ $t('sort') }} </label>
                <div>
                    <input type="number" class="form-control form-control-sm" v-model="model.Sort" />
                </div>
            </div>
        </div>
        <template #modal-footer>
            <button type="button" class="btn btn-success" @click="onSave">{{$t('Save')}}</button>
        </template>
    </b-modal>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        props: {
            value: {
                type: Object,
                default: {}
            }
        },
        data: function () {
            return {
                model: this.value,
                types: [],
                title: this.$t('add_new')
            }
        },
        created() {
            this.accountTypeList();
            var id = this.$route.params.id;
            if (id != undefined) {
                this.findById(id);
            }
        },
        validations: {
            model: {
                AccountTypeId: { required },
                Name: { required }
            }
        },
        methods: {
            findById: function (id) {
                var loading = this.$loading.show();
                this.$api().post('accounting/account/find', { Id: id }).then(res => {
                    if (this.$isValid(res)) {
                        this.model = res.data.Data;
                        this.title = '[' + this.model.Name + ']';
                    }
                }).finally(function () { loading.hide(); });
            },
            onSave: function () {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.$emit('save', this.model);
                }
            },
            accountTypeList: async function () {
                var res = await this.$api().post('accounting/types', {});
                if (this.$isValid(res)) {
                    this.types = res.data.Json.Types;
                }
            },
            typeChange() {
                for (var i = 0; i < this.types.length; i++) {
                    let item = this.types[i];
                    if (item.Id == this.model.AccountTypeId) {
                        this.model.AccountTypeName = item.Name;
                        break;
                    }
                }
            }
        },
        watch: {
            value(val) {
                this.$v.$reset();
                this.model = val;
            }
        }
    }
</script>
